﻿import { clientEntity } from '../model/entity/client-entity';

export function _clientEntity(clientId: any): any {
    if (clientId > 0) {
        return Object.freeze(clientEntity.find(clientId));
    }
    return null;
}

